<div class="section-title">
    {{ 'mimic.settings.valve-object.appearance.title' | translate }}
</div>
<div class="dropdown-group">
    <app-channel-select-input
        name="openingCount"
        label="mimic.settings.valve-object.appearance.opening-count"
        [value]="selectedOpeningCount"
        [itemList]="openingCountItemList"
        [dark]="true"
        (inputChange)="onOpeningCountChange($event)"></app-channel-select-input>
    <app-channel-select-input
        name="orientation"
        label="mimic.settings.valve-object.appearance.orientation"
        [value]="selectedOrientation"
        [itemList]="orientationItemList"
        [dark]="true"
        (inputChange)="onOrientationChange($event)"></app-channel-select-input>
</div>

<div class="section-title">
    {{ 'mimic.settings.valve-object.interaction.title' | translate }}
</div>
<div class="interaction-section">
    <div class="interaction-item">
        <div class="interaction-label">
            {{ 'mimic.settings.valve-object.interaction.open' | translate }}
        </div>
        <div
            class="select-channel-button"
            (click)="openActionChannelSelector(ValveActionType.OPEN)"
            *ngIf="!selectedOpenChannel">
            {{ 'mimic.settings.valve-object.interaction.select-channel' | translate }}
        </div>
        <div class="selected-channel-wrapper" *ngIf="selectedOpenChannel">
            <div class="selected-channel-detail-container">
                <h6 class="channel-name">
                    {{ selectedOpenChannel.opsData?.tag }}
                    {{ selectedOpenChannel.opsData?.name }}
                </h6>
                <div class="channel-info-line">
                    {{ selectedOpenChannel.group?.displayName }}
                </div>
                <div class="channel-info-line">
                    {{ selectedOpenChannel.group?.channelCategory?.category }}
                </div>
                <span class="channel-action-button change" (click)="openActionChannelSelector(ValveActionType.OPEN)">
                    {{ 'mimic.settings.valve-object.interaction.change' | translate }}
                </span>
            </div>
            <div class="remove-action-row">
                <span class="channel-action-button remove" (click)="removeChannel(ValveActionType.OPEN)">
                    {{ 'mimic.settings.valve-object.interaction.remove' | translate }}
                </span>
            </div>
        </div>
        <ng-container *ngIf="selectedOpenChannel && isChannelDigital(ValveActionType.OPEN)">
            <app-channel-select-input
                name="openChannelState"
                label="mimic.settings.valve-object.interaction.channel-state"
                [value]="selectedOpenChannelState"
                [itemList]="openChannelStateItemList"
                [dark]="true"
                (inputChange)="onChannelStateChange(ValveActionType.OPEN, $event)"></app-channel-select-input>
            <app-status-color-indicator
                [statusString]="selectedOpenChannelState"
                [color]="openChannelStateColor"
                [readonly]="true"></app-status-color-indicator>
        </ng-container>
        <ng-container *ngIf="selectedOpenChannel && isChannelAnalog(ValveActionType.OPEN)">
            <div class="percentage-input-wrapper dark">
                <p class="input-label dark" [class.show]="selectedOpenPercentage || selectedOpenPercentage === 0">
                    {{ 'mimic.settings.valve-object.interaction.opening-percentage' | translate }}
                </p>
                <input
                    type="number"
                    class="percentage-input dark"
                    [value]="selectedOpenPercentage"
                    (change)="onPercentageChange($event)"
                    (input)="onPercentageInput($event)"
                    [placeholder]="'mimic.settings.valve-object.interaction.opening-percentage' | translate"
                    [min]="percentageMinValue"
                    [max]="percentageMaxValue" />
                <span class="percentage-unit">%</span>
            </div>
            <ng-container *ngIf="shouldShowPercentagePositionDropdown()">
                <app-channel-select-input
                    #percentagePositionDropdown
                    name="percentagePosition"
                    label="mimic.settings.valve-object.interaction.indicator-position"
                    [value]="selectedOpenPercentagePositionKey"
                    [itemList]="percentagePositionItemList"
                    [dark]="true"
                    (inputChange)="onPercentagePositionChange($event)"></app-channel-select-input>
            </ng-container>
            <app-status-color-indicator
                [statusString]="'ON'"
                [color]="openChannelStateColor"
                [readonly]="true"></app-status-color-indicator>
        </ng-container>
        <div class="toggle-setting">
            <mat-slide-toggle
                [checked]="isOpenToggleEnabled"
                (change)="onFlashToggleChange(ValveActionType.OPEN, $event.checked)">
            </mat-slide-toggle>
            <span class="disabled-message">{{
                (isOpenToggleEnabled
                    ? 'mimic.settings.valve-object.interaction.flash-enabled'
                    : 'mimic.settings.valve-object.interaction.flash-disabled'
                ) | translate
            }}</span>
        </div>
        <ng-container *ngIf="isOpenToggleEnabled">
            <div
                class="select-channel-button"
                (click)="openFlashChannelSelector(ValveActionType.OPEN)"
                *ngIf="!selectedOpenFlashChannel">
                {{ 'mimic.settings.valve-object.interaction.select-channel' | translate }}
            </div>
            <div class="selected-channel-wrapper" *ngIf="selectedOpenFlashChannel">
                <div class="selected-channel-detail-container">
                    <h6 class="channel-name">
                        {{ selectedOpenFlashChannel.opsData?.tag }}
                        {{ selectedOpenFlashChannel.opsData?.name }}
                    </h6>
                    <div class="channel-info-line">
                        {{ selectedOpenFlashChannel.group?.displayName }}
                    </div>
                    <div class="channel-info-line">
                        {{ selectedOpenFlashChannel.group?.channelCategory?.category }}
                    </div>
                    <span class="channel-action-button change" (click)="openFlashChannelSelector(ValveActionType.OPEN)">
                        {{ 'mimic.settings.valve-object.interaction.change' | translate }}
                    </span>
                </div>
                <div class="remove-action-row">
                    <span class="channel-action-button remove" (click)="selectedOpenFlashChannel = undefined">
                        {{ 'mimic.settings.valve-object.interaction.remove' | translate }}
                    </span>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="interaction-item">
        <div class="interaction-label">
            {{ 'mimic.settings.valve-object.interaction.close' | translate }}
        </div>
        <div
            class="select-channel-button"
            (click)="openActionChannelSelector(ValveActionType.CLOSE)"
            *ngIf="!selectedCloseChannel">
            {{ 'mimic.settings.valve-object.interaction.select-channel' | translate }}
        </div>
        <div class="selected-channel-wrapper" *ngIf="selectedCloseChannel">
            <div class="selected-channel-detail-container">
                <h6 class="channel-name">
                    {{ selectedCloseChannel.opsData?.tag }}
                    {{ selectedCloseChannel.opsData?.name }}
                </h6>
                <div class="channel-info-line">
                    {{ selectedCloseChannel.group?.displayName }}
                </div>
                <div class="channel-info-line">
                    {{ selectedCloseChannel.group?.channelCategory?.category }}
                </div>
                <span class="channel-action-button change" (click)="openActionChannelSelector(ValveActionType.CLOSE)">
                    {{ 'mimic.settings.valve-object.interaction.change' | translate }}
                </span>
            </div>
            <div class="remove-action-row">
                <span class="channel-action-button remove" (click)="removeChannel(ValveActionType.CLOSE)">
                    {{ 'mimic.settings.valve-object.interaction.remove' | translate }}
                </span>
            </div>
        </div>
        <ng-container *ngIf="selectedCloseChannel && isChannelDigital(ValveActionType.CLOSE)">
            <app-channel-select-input
                name="closeChannelState"
                label="mimic.settings.valve-object.interaction.channel-state"
                [value]="selectedCloseChannelState"
                [itemList]="closeChannelStateItemList"
                [dark]="true"
                (inputChange)="onChannelStateChange(ValveActionType.CLOSE, $event)"></app-channel-select-input>
            <app-status-color-indicator
                [statusString]="selectedCloseChannelState"
                [color]="closeChannelStateColor"
                [readonly]="true"></app-status-color-indicator>
        </ng-container>
        <ng-container *ngIf="selectedCloseChannel && isChannelAnalog(ValveActionType.CLOSE)">
            <app-status-color-indicator
                [statusString]="'OFF'"
                [color]="closeChannelStateColor"
                [readonly]="true"></app-status-color-indicator>
        </ng-container>
        <div class="toggle-setting">
            <mat-slide-toggle
                [checked]="isCloseToggleEnabled"
                (change)="onFlashToggleChange(ValveActionType.CLOSE, $event.checked)">
            </mat-slide-toggle>
            <span class="disabled-message">{{
                (isCloseToggleEnabled
                    ? 'mimic.settings.valve-object.interaction.flash-enabled'
                    : 'mimic.settings.valve-object.interaction.flash-disabled'
                ) | translate
            }}</span>
        </div>
        <ng-container *ngIf="isCloseToggleEnabled">
            <div
                class="select-channel-button"
                (click)="openFlashChannelSelector(ValveActionType.CLOSE)"
                *ngIf="!selectedCloseFlashChannel">
                {{ 'mimic.settings.valve-object.interaction.select-channel' | translate }}
            </div>
            <div class="selected-channel-wrapper" *ngIf="selectedCloseFlashChannel">
                <div class="selected-channel-detail-container">
                    <h6 class="channel-name">
                        {{ selectedCloseFlashChannel.opsData?.tag }}
                        {{ selectedCloseFlashChannel.opsData?.name }}
                    </h6>
                    <div class="channel-info-line">
                        {{ selectedCloseFlashChannel.group?.displayName }}
                    </div>
                    <div class="channel-info-line">
                        {{ selectedCloseFlashChannel.group?.channelCategory?.category }}
                    </div>
                    <span
                        class="channel-action-button change"
                        (click)="openFlashChannelSelector(ValveActionType.CLOSE)">
                        {{ 'mimic.settings.valve-object.interaction.change' | translate }}
                    </span>
                </div>
                <div class="remove-action-row">
                    <span class="channel-action-button remove" (click)="selectedCloseFlashChannel = undefined">
                        {{ 'mimic.settings.valve-object.interaction.remove' | translate }}
                    </span>
                </div>
            </div>
        </ng-container>
    </div>
</div>

<div class="section-title">
    {{ 'mimic.settings.sensor.title' | translate }}
</div>
<div class="sensor-section">
    <app-alarm-color-indicator
        [title]="'channel.label.alarm.fu-unresponsive'"
        [color]="fuUnresponsiveColor"
        [enabled]="true"
        [showAlpha]="false">
    </app-alarm-color-indicator>
</div>
